import { useState } from "react";
import { format } from "date-fns";
import { XIcon, PencilIcon } from "@heroicons/react/outline";
import Modal from "@material-ui/core/Modal";
import { EditInvestmentForm } from "../Forms/EditInvestmentForm";
import { CalendarIcon, TrendingUpIcon } from "@heroicons/react/solid";
import CurrencyDisplay from "../Currency/CurrencyDisplay";

export const AdminInvestmentCard = ({ data, getUserInvestmentsRequest }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        className="flex items-center justify-center p-4 backdrop-blur-sm"
      >
        <div className="bg-white rounded-3xl w-full max-w-lg shadow-2xl outline-none relative overflow-hidden max-h-[90vh] overflow-y-auto">
          {/* Modal Header */}
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-100 flex justify-between items-center sticky top-0 z-10">
            <h3 className="font-heading font-bold text-lg text-gray-800">
              Edit Investment
            </h3>
            <button
              onClick={handleClose}
              className="p-1 rounded-full hover:bg-gray-200 transition-colors text-gray-500"
            >
              <XIcon className="w-6 h-6" />
            </button>
          </div>

          <div className="p-6">
            <EditInvestmentForm
              investment={data}
              handleClose={handleClose}
              getUserInvestmentsRequest={getUserInvestmentsRequest}
            />
          </div>
        </div>
      </Modal>

      {/* --- THE CARD --- */}
      <div className="group bg-white rounded-2xl shadow-sm hover:shadow-md border border-gray-100 p-5 transition-all duration-300 relative overflow-hidden">
        {/* Active Status Indicator Stripe */}
        <div
          className={`absolute left-0 top-0 bottom-0 w-1.5 ${
            data.isActive ? "bg-green-500" : "bg-gray-300"
          }`}
        ></div>

        <div className="pl-3 flex flex-col md:flex-row md:items-center justify-between gap-4">
          {/* Main Info */}
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-1">
              <h3 className="text-lg font-heading font-bold text-gray-900">
                {data?.planName || "Unknown Plan"}
              </h3>
              <span
                className={`text-[10px] uppercase font-bold px-2 py-0.5 rounded-full ${
                  data.isActive
                    ? "bg-green-100 text-green-700"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {data.isActive ? "Active" : "Inactive"}
              </span>
            </div>

            <div className="flex items-center text-xs text-gray-500 font-body mb-4">
              <CalendarIcon className="w-4 h-4 mr-1 text-gray-400" />
              Started:{" "}
              {data.createdAt &&
                format(new Date(data.createdAt), "MMM dd, yyyy")}
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-3 gap-4 border-t border-gray-50 pt-3">
              <div>
                <p className="text-xs text-gray-400 font-bold uppercase">
                  Invested
                </p>
                <p className="text-sm font-bold text-gray-900 flex items-center">
                  <CurrencyDisplay
                    usdAmount={data?.amount}
                    className="inline"
                  />
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-400 font-bold uppercase">
                  Growth
                </p>
                <p className="text-sm font-bold text-green-600 flex items-center">
                  <TrendingUpIcon className="w-3 h-3 mr-1" />
                  {data?.profitProduction}%
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-400 font-bold uppercase">
                  Claimable
                </p>
                <p className="text-sm font-bold text-primary flex items-center">
                  <CurrencyDisplay
                    usdAmount={data?.expectedReturn}
                    className="inline"
                  />
                </p>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <div className="md:border-l md:border-gray-100 md:pl-6 flex items-center justify-center">
            <button
              onClick={handleOpen}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-gray-50 text-gray-700 font-heading font-bold text-sm hover:bg-primary hover:text-white transition-all duration-200"
            >
              <PencilIcon className="w-4 h-4" />
              Edit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
